<template>
  <v-container fluid pa-0>
    <v-row align="center" justify="center" no-gutters>
      <page-heading :text="title"
                    class="mb-5"
                    text-center
      ></page-heading>
      <v-progress-linear class="mb-5"
                         color="rgba(255,255,255,0.5)"
                         height="15"
                         indeterminate
      ></v-progress-linear>
      <div class="text-center"
           v-if="details.via === 'sms'"
      >{{ $t(pageTranslationText.smsInfo) }}
      </div>
      <div class="text-center"
           v-else-if="details.via === 'whatsapp'"
      >{{ $t(pageTranslationText.whatsappInfo) }}
      </div>
      <div class="text-center" v-else-if="details.email || details.via === 'email'">
        {{ $t(pageTranslationText.emailInfo) }}
      </div>
      <div class="text-center" v-else>
        {{ $t(pageTranslationText.callInfo) }}
      </div>
    </v-row>
  </v-container>
</template>

<script>
    import PageHeading from "../framework/PageHeading";

    export default {
        components: {
            PageHeading
        },
        name: "VerifyLoader",
        props: {
            details: {
                required: true,
                type: Object,
            },
            pageTranslationText: {
                required: true,
                type: Object
            }
        },
        computed : {
          title(){
            if(this.details.email || this.details.via === 'email'){
              return this.$t(this.pageTranslationText.emailTitle, {email: this.details.email });
            }
            if(this.details.via === 'sms'){
              return this.$t(this.pageTranslationText.smsTitle, {mobile: this.details.mobile || this.$store.state.auth.maskedMobile });
            }else if(this.details.via === 'whatsapp'){
              return this.$t(this.pageTranslationText.whatsappTitle, {mobile: this.details.mobile || this.$store.state.auth.maskedMobile });
            }else {
              return  this.$t(this.pageTranslationText.callTitle, {mobile: this.details.mobile || this.$store.state.auth.maskedMobile});
            }
          }
        },
        mounted() {
            setTimeout(() => {
                this.$emit('done');
            }, 3000);
        }
    }
</script>

<style scoped>

</style>